import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=4dc1c5d4"
import script from "./GroupView.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports